import script from "./Collaboration.vue?vue&type=script&setup=true&lang=js"
export * from "./Collaboration.vue?vue&type=script&setup=true&lang=js"

import "./Collaboration.vue?vue&type=style&index=0&id=07812051&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07812051"]])

export default __exports__